export const ACTUALIZAR_LIST_NIVEL1 = "ACTUALIZAR_LIST_NIVEL1";
export const MODIFICAR_NIVEL1 = "MODIFICAR_NIVEL1";
export const AGREGAR_NIVEL1 = "AGREGAR_NIVEL1";  
export const ELIMINAR_NIVEL1 = "ELIMINAR_NIVEL1";